module.exports = __webpack_public_path__ + "static/media/audience.b20e1693.svg";